import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material

//Component
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
//Function
import { DownloadFile, GetListHistory } from "./api";
import { getHistoryColumns } from "./columns/export-history";
import { GetUser } from "../../utils/sessions";
import { url, method } from "./signalr";
import { useSignalR } from "../function-api/useSignalR";
import ViewDetail from "./view-detail";

function ExportQuery() {
  //State
  const [DataList, setDataList] = useState([]);

  const [detail, setDetail] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [keepSearch, setKeepSearch] = useState(false);

  const fetch = async () => {
    let param = { "USER_ID": GetUser(), "MODE": "Refresh" };
    let res = await GetListHistory(param);
    setDataList(res);
  }
  //Effect
  useEffect(() => {
    fetch();
  }, []);

  const signalRHandler = useCallback(async (data) => {
    fetch();
    setKeepSearch(true);
  }, []);

  useSignalR(url, method, signalRHandler);


  const onCloseViewModal = () => {
    setOpenModal(false);
  };

  const onViewModal = (pID) => {
    const fetch = async () => {
      let res = DataList.find((e) => e.ID === pID);
      //console.log(res);
      setDetail(res);
    }
    fetch();
    setOpenModal(true);
  }

  const onExportData = async (pID) => {
    let param = { "ID": pID };
    let res = await DownloadFile(param);
    //console.log(res);
    if(res?.FileName)
      window.open( `${API_URL.Query}/Export/`+res?.FileName, '_blank');

  }


  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Export Query">
          <FormProvider>
            <ReactTable
              keyField="ID"
              data={DataList}
              columns={getHistoryColumns(onExportData,onViewModal)}
              keepStateSearch={keepSearch}
            />
          </FormProvider>
        </BoxTemplate1>
        <ViewDetail
          open={openModal}
          onClose={onCloseViewModal}
          Detail={detail}
        />
      </BaseContainer>
    </div>
  );
}
export default ExportQuery;
